// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB--uLqls03FnQIfFTNkH8nWAQ98bFP_4M",
  authDomain: "bizmate2u-69a2a.firebaseapp.com",
  projectId: "bizmate2u-69a2a",
  storageBucket: "bizmate2u-69a2a.appspot.com",
  messagingSenderId: "934557775367",
  appId: "1:934557775367:web:fc879f7080c8a084b8dca2",
  measurementId: "G-RE9BEB8DF0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics, logEvent };